import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { createSession } from "@insite/client-framework/Services/SessionService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    chain,
    RequestSession as DefaultRequestSession,
    NavigateToReturnUrl as DefaultNavigateToReturnUrl,
} from "@insite/client-framework/Store/Context/Handlers/SignIn";
import {
    promoteContextCookiesToSharedDomain,
    removeSharedContextCookies,
    stopWatchingForSharedContextChange,
    watchForSharedContextChange,
} from "@tSurya/Handlers/SharedCookieContext";

const RequestSession: typeof DefaultRequestSession = async props => {
    if (!props.tokenSuccessfullyRequested) {
        return;
    }

    removeSharedContextCookies();

    const { password, rememberMe, keepMeSignedIn, returnUrl, userName } = props.parameter;

    stopWatchingForSharedContextChange();
    const session = await createSession({
        password,
        rememberMe,
        keepMeSignedIn,
        returnUrl,
        userName,
        accessToken: props.apiResult?.access_token,
    });

    if (!session.successful) {
        watchForSharedContextChange();
        props.parameter.onError?.(session.errorMessage, session.statusCode);
        return;
    }

    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: session.result,
    });

    props.authenticatedSession = session.result;

    // Promote context cookies to shared domain for cross-brand SSO
    promoteContextCookiesToSharedDomain();
};

const NavigateToReturnUrl: typeof DefaultNavigateToReturnUrl = async props => {
    if (!props.authenticatedSession) {
        return;
    }

    const returnUrl = props.parameter.returnUrl;

    if (returnUrl) {
        try {
            const url = new URL(returnUrl, window.location.origin);

            const restrictedPaths = [
                "/website-registration",
                "/thankyou",
            ];

            const normalizedPath = url.pathname
                .replace(/\/+$/, "")
                .toLowerCase();

            const shouldRedirectToHome =
                url.origin === window.location.origin &&
                restrictedPaths.includes(normalizedPath);

            if (shouldRedirectToHome) {
                const homePageUrl = getHomePageUrl(props.getState());

                window.location.replace(homePageUrl || "/");
                return;
            }
        } catch {
            // Let the default handler validate the URL.
        }
    }

    return DefaultNavigateToReturnUrl(props);
};

replaceInChain(chain, DefaultRequestSession, RequestSession);
replaceInChain(chain, DefaultNavigateToReturnUrl, NavigateToReturnUrl);